import src from "IMAGE";
export default { src, width: 4800, height: 1344, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPklEQVR42i3I2woAERhF4a3+mWmukRDlUFx4/+ezlYuvVQvaS47tWd+vEgBHlvxlYKMUE6TLqypHp9NJg9IGZxMC6PlOWNIAAAAASUVORK5CYII="};
